// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f6a42149","952":"44bd4383"}[chunkId] + ".chunk.js";
};